import React from "react";
import { Select, Spin } from "antd";

import { AppStrings } from "../../../../utils/constants/AppStrings";
import type { Sport } from "../EventMarkets/eventMarketsTypes";

interface FuturesSportSelectProps {
  sports: Sport[];
  selectedId: Sport["id"] | null;
  onSelect: (id: Sport["id"]) => void;
  isLoading: boolean;
  isError: boolean;
}

function FuturesSportSelect({
  sports,
  selectedId,
  onSelect,
  isLoading,
  isError,
}: FuturesSportSelectProps): React.ReactElement {
  return (
    <div
      className="futures-filter-field futures-sport-select"
      data-testid="futures-sport-select"
    >
      <label className="futures-filter-label" htmlFor="futuresSportSelect">
        {AppStrings.SPORT}
      </label>

      {isLoading ? (
        <div
          className="futures-filter-state"
          data-testid="futures-sports-loading"
        >
          <Spin size="small" />
        </div>
      ) : isError ? (
        <div
          className="futures-filter-state"
          data-testid="futures-sports-error"
        >
          {AppStrings.FAILED_TO_LOAD_SPORTS}
        </div>
      ) : sports.length === 0 ? (
        <div
          className="futures-filter-state"
          data-testid="futures-sports-empty"
        >
          {AppStrings.NO_SPORTS_FOUND}
        </div>
      ) : (
        <Select
          id="futuresSportSelect"
          className="futures-filter-select"
          data-testid="futures-sport-select-input"
          showSearch
          optionFilterProp="label"
          value={selectedId ?? undefined}
          onChange={(value) => onSelect(value)}
          placeholder={AppStrings.FUTURES_SPORT_PLACEHOLDER}
          options={sports.map((sport) => ({
            value: sport.id,
            label: sport.name,
          }))}
          getPopupContainer={(trigger) => trigger.parentElement || document.body}
        />
      )}
    </div>
  );
}

export default FuturesSportSelect;
